<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    let returnTo = '/game-assist/';

    // Check if return_to is in query params
    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const queryReturnTo = urlParams.get('return_to');

        if (queryReturnTo) {
            // Ensure it's a relative path by removing any protocol and domain
            returnTo = queryReturnTo.replace(/^(?:https?:)?(?:\/\/[^\/]+)?(\/.*)?$/, '$1');
        }
    });
</script>

<div class="container">
    <div class="mb-4">
        <a href="/account/#/login" class="text-primary text-sm">
            &lt; {$_('login.back_to_email_login')}
        </a>
    </div>

    <h1 class="brand-font my-6">{$_('login.phone_title')}</h1>

    <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col justify-start mt-6 align-flex-start">
            <p class="text-lg">{$_('login.loginInstruction')}</p>
            <a href="https://wa.me/31610163001" target="_blank" role="button" class="mt-4 button-primary">
                {$_('signup.ask_app_whatsappLink')}
            </a>
            <p class="text text-xs mt-4 text-italic text-gray-500">
                <ion-icon name="information-circle-outline"></ion-icon>
                {$_('login.noSignalSupport')}
            </p>
            <hr class="my-6">
            <p class="text-xs">
                {$_('login.noAccount')}
                <a href="/account/#/signup" class="text-primary">{$_('login.signup')}</a>
            </p>
            <p class="text-xs mt-2">
                {$_('login.have_email')}
                <a href="/account/#/login" class="text-primary">{$_('login.use_email_login')}</a>
            </p>
        </div>
        <div class="flex justify-center">
            <img class="mobile_preview mt-6" src="/img/mobile_pankla_login.png" alt="mobile_with_login_message">
        </div>
    </div>
</div>

<style>
    .mobile_preview {
        max-height: 300px;
        width: auto;
        margin: auto;
    }
</style>
